export default function Menu() {
	// Find the mobile menu trigger, mobile menu, and mobile item triggers
	const mobileMenuTrigger = document.querySelector('.js-mobile-menu-trigger')
	const mobileMenu = document.querySelector('.js-mobile-menu')
	const mobileItemTriggers = document.querySelectorAll('.js-mobile-item-trigger')

	// Toggle the mobile menu
	if (mobileMenuTrigger) {
		mobileMenuTrigger.addEventListener('click', debounce(() => {
			if (mobileMenu) {
				const isActive = mobileMenu.classList.contains('active')
				mobileMenu.classList.toggle('active')

				if (isActive) {
					closeAllItems()
				}
			}

			const icon = mobileMenuTrigger.querySelector('ion-icon')
			if (icon) {
				if (icon.getAttribute('name') === 'menu-sharp') {
					icon.setAttribute('name', 'close-sharp')
				} else {
					icon.setAttribute('name', 'menu-sharp')
				}
			}
		}, 150))
	}

	mobileItemTriggers.forEach(trigger => {
		trigger.addEventListener('click', debounce(() => {
			trigger.classList.toggle('active')
			const nextElement = trigger.nextElementSibling
			if (nextElement) {
				nextElement.classList.toggle('active')
			}
		}, 150))
	})

	if (window.innerWidth >= 1024 && typeof closeMenu === "function") {
		closeMenu()
	}

	window.addEventListener('resize', debounce(() => {
		if (window.innerWidth >= 1024 && typeof closeMenu === "function") {
			closeMenu()
		}
	}, 150))

	function closeMenu() {
		if (mobileMenu) {
			mobileMenu.classList.remove('active')
		}

		const icon = mobileMenuTrigger ? mobileMenuTrigger.querySelector('ion-icon') : null
		if (icon) {
			icon.setAttribute('name', 'menu-sharp')
		}

		closeAllItems()
	}

	function closeAllItems() {
		mobileItemTriggers.forEach(trigger => {
			trigger.classList.remove('active')
			const nextElement = trigger.nextElementSibling
			if (nextElement) {
				nextElement.classList.remove('active')
			}
		})
	}

	// Debounce function: Executes the given function after waiting for the specified delay.
	function debounce(func, wait) {
		let timeoutId = null

		return function () {
			if (timeoutId !== null) {
				clearTimeout(timeoutId)
			}

			timeoutId = setTimeout(() => {
				func()
				timeoutId = null
			}, wait)
		};
	}
}
